import React from 'react';
import ReactDOM from 'react-dom/client';
import {BrowserRouter} from 'react-router-dom';
import {QueryProvider} from '@rocket-ui/tsp-queries';
import {NotificationsContainer, WithUserInteraction} from '@rocket-ui/user-interaction';
import {App} from 'app/App';
import {setupUnauthorizedRedirect} from 'app/setupUnauthorizedRedirect';
import '@rocket-ui/styles/global.css';

setupUnauthorizedRedirect();
import 'app/lk-mobile-base.css';
import 'shared/styles/index.css';
import 'shared/assets/fonts/fonts.css';

const rootEl = document.getElementById('root');

if (!rootEl) {
	throw new Error('Root element #root not found');
}

ReactDOM.createRoot(rootEl).render(
	<React.StrictMode>
		<QueryProvider optimized={import.meta.env.PROD} position="bottom-right">
			<WithUserInteraction>
				<BrowserRouter>
					<App />
				</BrowserRouter>
				<NotificationsContainer />
			</WithUserInteraction>
		</QueryProvider>
	</React.StrictMode>,
);
